import Breadcrumb from 'components/Navigation/Breadcrumb'
import TitleMenu from 'components/Navigation/TitleMenu'
import useTranslation from 'utils/hooks/useTranslation'
import CustomSelector from './CustomSelector'
import { SvgAerothermie, SvgGeothermie, SvgSolutionHybrides, SvgDeportee, SvgInstantanee, SvgIntegree, SvgSans } from 'components/svg'
import { useCallback, useEffect, useState } from 'react'
import * as dd from 'constants/dropdown'
import Input, { InputType } from 'components/shared/inputs/input'
import { convertToSelect } from 'utils'
import { usePopup } from 'providers/PopupProvider'
import { TarifPopup } from 'components/popups/TarifPopup'
import NavigationButtons from 'components/NavigationButtons'
import { addNotification } from 'store/componentsSlice'
import { useAppDispatch, useAppSelector } from 'store/hooks'
import { useSalesNetwork } from 'utils/hooks/useSalesNetworks'
import * as ProjectStore from 'store/projectSlice'
import useCustomForm from 'utils/hooks/useCustomForm'
import { hpChoiceDefaultForm, HpChoiceSchema, type HpChoiceForm } from 'store/hpChoiceSlice'
import { yupResolver } from '@hookform/resolvers/yup'
import Checkbox, { CheckboxType } from 'components/shared/inputs/checkbox'
import { } from 'components/svg'
import { useProject } from 'utils/hooks/useProject'
import { toJS } from 'utils/helpers'
import { LinkButton } from 'components/LinkButton'
import { DHWChoicePopup } from 'components/popups/DHWChoicePopup'
import { RadioGroup } from 'components/RadioGroup'
import { RadioGroupDelay } from 'components/RadioGroupDelay'

export const TYPEPOMPE_ITEMS = [
  {
    value: '1',
    code: '1',
    label: 'AEROTHERMAL',
    icon: <SvgAerothermie />,
  },
  {
    value: '2',
    code: '2',
    label: 'GEOTHERMAL',
    icon: <SvgGeothermie />,
  },
  {
    value: '3',
    code: '3',
    label: 'HYBRID',
    icon: <SvgSolutionHybrides />,
  },
]

export const typesECSDefault = [
  { paramCode: '0', code: 'sans', label: 'SELECT_ECS_SANS', icon: <SvgSans /> },
  { paramCode: '1', code: 'deportee', label: 'SELECT_ECS_DEP', icon: <SvgDeportee /> },
  { paramCode: '2', code: 'integree', label: 'SELECT_ECS_INT', icon: <SvgIntegree /> },
]
export const typesECSInst = [{ paramCode: '3', code: 'instantanee', label: 'SELECT_ECS_INST', icon: <SvgInstantanee /> }]
export const typesECSInstDep = [
  { paramCode: '3', code: 'instantanee', label: 'SELECT_ECS_INST', icon: <SvgInstantanee /> },
  { paramCode: '1', code: 'deportee', label: 'SELECT_ECS_DEP', icon: <SvgDeportee /> },
]
export const typesECSIntegree = [{ paramCode: '2', code: 'integree', label: 'SELECT_ECS_INT', icon: <SvgIntegree /> }]

const ProjectStepHPChoice: React.FC = () => {
  const { t, tHtml } = useTranslation()
  const dispatch = useAppDispatch()
  const { network, isAtlantic, isThermor } = useSalesNetwork()
  const projectStore = useAppSelector((state) => state.project)
  const { updateForm, resetResults } = useProject()
  const [typesECSChanged, setTypesECSChanged] = useState<boolean>(false)
  const [data, setData] = useState({
    typologies: dd.typologies,
    captages: dd.captages,
    utilisations: dd.utilisations,
    energies: dd.energies,
    alimentations: dd.alimentations,
    abonnements: dd.abonnementsMono,
    releveChaudiere: dd.releveChaudiere,
    anneesChaudiere: dd.anneesChaudiere,
    typesChaudiere: dd.typesChaudiere,
    energiesChaudiere: dd.energiesChaudiere,
    typesECS: typesECSDefault,
    nbOccupants: dd.nbOccupants,
    IDU_types: [] as any,

    configOk: false,
    hybridOnly: false,
  })

  const hpChoiceformStore = useAppSelector((state) => state.project.project.forms.hpChoiceStep)
  const module_types = network?._parameters.Module_type;
  const DHW_Module_1S = network?._parameters.DHW_Module_1S;
  const DHW_Module_2S = network?._parameters.DHW_Module_2S;
  const installation_survey = network?._parameters.installation_survey;

  const {
    control,
    watch,
    setValue,
    reset,
    getValues,
    formState: { errors },
    onSelect,
    trigger,
  } = useCustomForm<HpChoiceForm>({
    defaultValues: hpChoiceformStore.form ?? hpChoiceDefaultForm,
    resolver: yupResolver(HpChoiceSchema) as any,
    mode: 'all',
  })

  const { openPopup, closeLastPopup } = usePopup()

  const [heatPumpType, typeECS, energie, utilisation, releveChaudiere, typologie, DHWChoice2, delay] = watch([
    'heatPumpType',
    'typeECS',
    'energie',
    'utilisation',
    'releveChaudiere',
    'typologie',
    'DHWChoice2',
    'delay',
  ])

  const heatingZones = projectStore.project.forms.heatModeStep?.form?.zones ?? []
  const isThreeZoneAerothermal = heatPumpType === '1' && heatingZones.length === 3



  const hybridOnly = useCallback(() => {
    return (
      isAtlantic &&
      projectStore.project.deperds &&
      projectStore.project.deperds.Study?.StudyDeperdition > 21000 &&
      projectStore.project.deperds.Study?.StudyDeperdition < 29000
    )
  }, [isAtlantic, projectStore])

  const usageOfHightTempEmitter = useCallback(() => {
    return projectStore.project.deperds?.Study?.StudyMaximumTempTransmitter > 60
  }, [projectStore.project.deperds?.Study?.StudyMaximumTempTransmitter])

  const checkEnergyAndUtilisation = useCallback(
    (forceDefaultValue = true) => {
      let typesECS, alimentations

      if (heatPumpType === '3') {
        typesECS = typesECSDefault.concat(typesECSInst)
        alimentations = dd.alimentations

        if (energie === 'propane' && utilisation === '1') {
          typesECS = typesECS.filter((item) => item.code !== 'instantanee')
        }

        if (energie === 'fioul' && utilisation === '1') {
          typesECS = typesECS.concat(typesECSInstDep)
        }

        if (energie === 'fioul' && utilisation === '2') {
          typesECS = typesECSIntegree
        }
      } else {
        typesECS = typesECSDefault
        alimentations = dd.alimentations
      }

      if (forceDefaultValue) {
        //debugger
        if (typesECS.length === 1) {
          setValue('typeECS', typesECS[0].code)
          setValue('typeECS_i18nCode', typesECS[0].label)
        } else {
          setValue('typeECS', '')
          setValue('typeECS_i18nCode', '')
        }
      }

      const filteredTypes = module_types ? typesECS.filter(t => module_types?.split(',')?.includes(t.paramCode)) : typesECS;

      setData((prevData) => ({
        ...prevData,
        typesECS: filteredTypes,
        alimentations,
        energies: utilisation === '1' ? dd.energies_rt2012 : dd.energies,
      }))
    },
    [setValue, energie, heatPumpType, utilisation],
  )

  const onSelectDefaultDHWChoice2 = useCallback((IDU_types: any[], index: number) => {
    const code = IDU_types[index]?.code || "";
    // let allowChange = true;
    // if (IDU_types.filter(e => e.code === DHWChoice2).length > 0) {
    //   allowChange = false;
    // }
    // if (code != DHWChoice2 && allowChange) {
    onSelect?.('DHWChoice2', code, IDU_types[index]?.label || "" as string)
    //}
  }, [/*DHWChoice2,*/ onSelect])

  const checkTypologyAndTypeECS = useCallback(() => {
    let IDU_types: any = []
    let defaultIndex: number | null = null
    let filteredIDU_types: any = []

    if (heatPumpType === '1') {
      if (typeECS == 'sans' || typeECS == 'deportee') {
        if (typologie == '0' || typologie == '2') {
          //ind or monobloc
          IDU_types = [dd.IDU_types_classique, dd.IDU_type_compact, dd.IDU_types_ind]
        } else if (typologie == '1') {
          //split
          IDU_types = [dd.IDU_types_classique, dd.IDU_types_ind]
        }
        filteredIDU_types = DHW_Module_1S ? IDU_types.filter((t: any) => DHW_Module_1S?.split(',')?.includes(t.paramCode)) : IDU_types;
        defaultIndex = isThreeZoneAerothermal
          ? filteredIDU_types.findIndex((item: any) => item.code === 'compact')
          : 0
        if (defaultIndex === null || defaultIndex < 0) defaultIndex = 0
      } else if (typeECS == 'integree') {
        IDU_types = dd.IDU_type_integree
        filteredIDU_types = DHW_Module_2S && DHW_Module_2S?.split(',').length == 1 ?
          IDU_types.filter((t: any) => DHW_Module_2S?.split(',')?.includes(t.paramCode)) : IDU_types;

        defaultIndex = 0
      }
    }

    if (typesECSChanged) {
      if (defaultIndex !== null) {
        onSelectDefaultDHWChoice2(filteredIDU_types, defaultIndex)
      } else {
        onSelect?.('DHWChoice2', '', '', false, false)
      }
    }

    setTypesECSChanged(false)

    setData((prevData) => ({
      ...prevData,
      IDU_types: filteredIDU_types,
    }))
  }, [typologie, typeECS, heatPumpType, isThreeZoneAerothermal, onSelect, onSelectDefaultDHWChoice2, typesECSChanged])

  useEffect(() => {
    if (projectStore.project.forms.hpChoiceStep.form) {
      reset({ ...getValues(), ...projectStore.project.forms.hpChoiceStep.form })
    } else {
      onHeatPumpTypeChange('1', 'AEROTHERMAL')

      if (hybridOnly()) {
        onHeatPumpTypeChange('3', 'HYBRID')
        setData((prevData) => ({ ...prevData, hybridOnly: true }))
      }
    }
    checkEnergyAndUtilisation(false)
  }, [network])

  useEffect(() => {
    checkEnergyAndUtilisation(false)
  }, [energie, utilisation])

  useEffect(() => {
    checkTypologyAndTypeECS()
  }, [typeECS, typologie])

  useEffect(() => {
    checkEnergyAndUtilisation(false)
  }, [heatPumpType])

  useEffect(() => {
    if (!isThreeZoneAerothermal) return

    if (!typologie) {
      onSelect?.('typologie', '0', 'SELECT_TYPO_IND', false, false)
    }

    if (!typeECS) {
      onSelect?.('typeECS', 'sans', 'SELECT_ECS_SANS', false, false)
      setValue('nbOccupants', '', { shouldDirty: false, shouldTouch: false })
    }
  }, [isThreeZoneAerothermal, onSelect, setValue, typeECS, typologie])

  useEffect(() => {
    if (!isThreeZoneAerothermal || DHWChoice2 || !data.IDU_types.length) return

    const compactModule = data.IDU_types.find((item: any) => item.code === 'compact')
    if (compactModule) {
      onSelect?.('DHWChoice2', compactModule.code, compactModule.label, false, false)
    }
  }, [DHWChoice2, data.IDU_types, isThreeZoneAerothermal, onSelect])

  useEffect(() => {
    if (network?._parameters.enableMonobloc) {
      setData((prevData) => ({
        ...prevData,
        typologies: dd.typologiesWithMonobloc,
      }))
    }

    if (network?._parameters.enableMultiElecSubscription) {
      setData((prevData) => ({
        ...prevData,
        abonnements: dd.abonnementsMulti,
      }))
    }
  }, [])

  const onReleveChaudiereChange = useCallback((e: any) => {
    const { value } = e.currentTarget.checked
    if (!value && heatPumpType === '2' && usageOfHightTempEmitter()) {
      dispatch(
        addNotification({
          type: 'warning',
          message: t('BOILER_RELIEVING_EXCEPTION'),
        }),
      )
    } else if (value && heatPumpType === '3') {
      dispatch(
        addNotification({
          type: 'warning',
          message: t('BOILER_RELIEVING_WITH_HYBRID_FORBID'),
        }),
      )
    } else {
      const chaudiereValue = e.currentTarget.checked ? 'chaudiere' : 'sans'
      setValue('releveChaudiere', chaudiereValue, { shouldDirty: true, shouldValidate: true, shouldTouch: true })
    }
  }, [dispatch, heatPumpType, setValue, t, usageOfHightTempEmitter])

  const onChangeUtilisation = useCallback((code?: string) => {
    const label = data.utilisations.find((item) => item.code === code)?.label
    onSelect?.('utilisation', code, label as string)

    onSelect?.('energie', '', '', false, false)
  }, [data.utilisations, onSelect])

  const onChangeEnergie = useCallback((code?: string) => {
    const label = data.energies.find((item) => item.code === code)?.label
    onSelect?.('energie', code, label as string)
  }, [data.energies, onSelect])

  const onChangeDHWChoice2 = useCallback((code?: string) => {
    const label = data.IDU_types.find((item: any) => item.code === code)?.label
    onSelect?.('DHWChoice2', code, label as string)
  }, [data.IDU_types, onSelect])

  const enabledHeatPumpByType = useCallback((type: string) => {
    if (!network?._parameters.heatPumpTypes) return true
    try {
      const heatPumpTypesArray = network?._parameters.heatPumpTypes.split(',')
      return heatPumpTypesArray.find((hpt) => hpt == type)
    } catch {
      return true
    }
  }, [network?._parameters.heatPumpTypes])

  const submit = useCallback(async () => {
    if (installation_survey) {
      setValue('isDelayOpen', true)
    }
    const values = getValues()
    const isValid = await trigger() // validate all fields
    if (isValid) {
      resetResults()
      updateForm('hpChoiceStep', { form: toJS(values) })
      return Promise.resolve()
    } else {
      dispatch(
        addNotification({
          type: 'error',
          message: t('SOME_FIELDS_NEED_YOUR_ATTENTION'),
        }),
      )
      return Promise.reject(t('SOME_FIELDS_NEED_YOUR_ATTENTION'))
    }
  }, [errors, installation_survey, trigger, resetResults, updateForm, dispatch, t]);



  const onHeatPumpTypeChange = useCallback(
    (code?: string, label?: string) => {
      onSelect?.('heatPumpType', code, label as string, false, true)
      onSelect?.('typologie', '', '', false, false)
      setValue('captage', '' as any)
      onSelect?.('utilisation', '' as any, '', false, false)
      setValue('energie', '' as any)
      setValue('nbOccupants', '' as any)

      checkEnergyAndUtilisation()
      if (code !== '3' && usageOfHightTempEmitter()) {
        setValue('releveChaudiere', 'chaudiere')
      } else if (code === '3') {
        setValue('releveChaudiere', 'sans')
        onSelect?.('utilisation', '2')
      }

      onSelect?.('DHWChoice2', '', '', false, false)
    },
    [onSelect, checkEnergyAndUtilisation, setValue, usageOfHightTempEmitter],
  )

  const ontypeECSChange = useCallback(
    (code?: string, label?: string) => {
      onSelect?.('typeECS', code, label as string)

      if (code === 'sans') {
        setValue('nbOccupants', '', { shouldDirty: true, shouldTouch: true })
      } else if (projectStore.project.simulationCool) {
        setValue('nbOccupants', projectStore.project.forms.coolModeStep.form?.nbPeoples)
      }

      setTypesECSChanged(true)
    },
    [onSelect, setValue, projectStore.project.forms.coolModeStep.form?.nbPeoples, projectStore.project.simulationCool],
  )

  const onnbOccupantsChange = (e: any) => {
    setValue('nbOccupants', e, { shouldDirty: true, shouldValidate: true })

    if (projectStore.project.simulationCool) {
      projectStore.project.forms.coolModeStep.form.nbPeoples = e
    }
  }

  const onOpenPopupElectricity = (e: any) => {
    e.preventDefault()
    openPopup(<TarifPopup closePopup={closeLastPopup}></TarifPopup>)
  }

  const onDelayChange = useCallback(
    (value: string) => {
      setValue('delay', value, { shouldDirty: true, shouldValidate: true, shouldTouch: true })
    },
    [setValue],
  )

  const onOpenPopupDHWChoice = (e: any) => {
    e.preventDefault()
    openPopup(<DHWChoicePopup closePopup={closeLastPopup}></DHWChoicePopup>)
  }

  const ElectricSubscriptionLabel = (
    <group data-align="center" data-width="auto" data-gap="10" data-weight="400">
      <text data-text-size="medium" data-ellipsis="" data-color="grey-color-dark" data-name="custom_label">
        {tHtml('ELECTRIC_SUBSCRIPTION')}
      </text>
      <i data-space-horizontal="5" data-color="red">
        *
      </i>
      <LinkButton onClick={onOpenPopupElectricity} title={t('SEE_PRICE')}></LinkButton>
    </group>
  )

  const DHWChoiceLabel = (
    <group data-align="center" data-width="auto" data-gap="10" data-weight="400">
      <text data-text-size="medium" data-ellipsis="" data-color="grey-color-dark" data-name="custom_label">
        {tHtml('IDU_TYPE_TITLE')}
      </text>
      <i data-space-horizontal="5" data-color="red">
        *
      </i>
      <LinkButton onClick={onOpenPopupDHWChoice} title={t('IDU_HELP_INFO')}></LinkButton>
    </group>
  )

  return (
    <>
      <TitleMenu title={projectStore.project.id ? projectStore.project.header.projectRef : t('MMENU_NEW_SIMULATION')} />
      <Breadcrumb handleSubmit={submit} />

      <group data-direction="column" data-align="center" data-height="autofit">
        <group data-space="20" data-gap="20" data-max-length="850" data-direction="column">
          <group data-space-vertical="20">
            <text data-weight="400" data-text-size="medium" data-ellipsis="" data-color="grey-color-dark">
              <i data-space-horizontal="5" data-color="red">
                *
              </i>{' '}
              <i>{t('REQUIRED_FIELDS')}</i>
            </text>
          </group>

          <group data-direction="column" data-gap="20">
            <text data-weight="600" data-text-size="large" data-ellipsis="" data-color="grey-color-dark">
              {t('HEATPUMP_TYPE')}
            </text>

            <group data-gap="20" data-align="center" data-name="custom_option">
              <CustomSelector
                name="heatPumpType"
                control={control}
                items={TYPEPOMPE_ITEMS}
                selected={heatPumpType}
                onChange={onHeatPumpTypeChange}
                customFilter={enabledHeatPumpByType}
              />
            </group>
          </group>

          {heatPumpType === '1' && (
            <group data-gap="20">
              <group data-length="autofit" data-fit="1" data-direction="column" data-size="large">
                <Input
                  type={InputType.Select}
                  label={'TYPOLOGY'}
                  requiredLabel={true}
                  control={control}
                  name="typologie"
                  options={convertToSelect(data.typologies)}
                  translateValue={true}
                  allowSearch={true}
                  size="large"
                  placeholder={`${t('TYPOLOGY')}`}
                />
              </group>
            </group>
          )}
          {heatPumpType === '2' && (
            <group data-gap="20">
              <group data-length="autofit" data-fit="1" data-direction="column" data-size="large">
                <Input
                  type={InputType.Select}
                  label={'CAPTURE_TYPE'}
                  requiredLabel={true}
                  control={control}
                  name="captage"
                  options={convertToSelect(data.captages)}
                  translateValue={true}
                  allowSearch={true}
                  size="large"
                  placeholder={`${t('CAPTURE_TYPE')}`}
                />
              </group>
            </group>
          )}
          {heatPumpType === '3' && (
            <group data-gap="20">
              <group data-length="forcefit" data-fit="1" data-direction="column">
                <Input
                  type={InputType.Select}
                  label={'USAGE'}
                  requiredLabel={true}
                  control={control}
                  name="utilisation"
                  options={convertToSelect(data.utilisations)}
                  translateValue={true}
                  allowSearch={true}
                  size="large"
                  placeholder={`${t('USAGE')}`}
                  onChange={(e: any) => onChangeUtilisation(e)}
                />
              </group>

              <group data-length="forcefit" data-fit="1" data-direction="column">
                <Input
                  type={InputType.Select}
                  label={'ENERGY'}
                  requiredLabel={true}
                  control={control}
                  name="energie"
                  options={convertToSelect(data.energies)}
                  translateValue={true}
                  //disabled={!departments}
                  allowSearch={true}
                  size="large"
                  placeholder={`${t('ENERGY')}`}
                  onChange={(e: any) => onChangeEnergie(e)}
                />
              </group>
            </group>
          )}

          <space data-height="20"></space>

          <group data-direction="column" data-gap="20">
            <text data-weight="600" data-text-size="large" data-ellipsis="" data-color="grey-color-dark">
              {t('ELECTRIC_INFOS')}
            </text>

            <group data-gap="20" data-align="center">
              <group data-length="autofit" data-fit="1" data-direction="column" data-size="large">
                <Input
                  type={InputType.Select}
                  label={'POWER_SUPPLY'}
                  requiredLabel={true}
                  control={control}
                  name="alimentation"
                  options={convertToSelect(data.alimentations)}
                  translateValue={true}
                  allowSearch={true}
                  size="large"
                  placeholder={`${t('POWER_SUPPLY')}`}
                />
              </group>
            </group>

            <group data-gap="20" data-align="center">
              <group data-length="autofit" data-fit="1" data-direction="column" data-size="large">
                <Input
                  type={InputType.Select}
                  //label={t("ELECTRIC_SUBSCRIPTION")}
                  label={ElectricSubscriptionLabel}
                  requiredLabel={true}
                  control={control}
                  name="abonnement"
                  options={convertToSelect(data.abonnements)}
                  translateValue={true}
                  allowSearch={true}
                  size="large"
                  placeholder={`${t('ELECTRIC_SUBSCRIPTION')}`}
                />
              </group>
            </group>
          </group>

          <group data-align="center" data-space-vertical="20" data-text-size="large" data-weight="600">
            <group data-gap="10">
              <Checkbox
                checkboxType={CheckboxType.StringValue}
                name="releveChaudiere"
                control={control}
                checkboxProps={{ 'data-lable-position': 'left', 'data-gap': '10' }}
                label={t('HEATPUMP_SUBSTITUTION')}
                simple
                onChange={onReleveChaudiereChange}
                disabled={heatPumpType === '3'}
                stringCheckedValue="chaudiere"
                checkbox
              />
            </group>
          </group>

          {releveChaudiere === 'chaudiere' && (
            <group data-gap="20" data-direction="column">
              <group data-length="autofit" data-direction="column" data-size="large">
                <Input
                  type={InputType.Select}
                  label={'BOILER_AGE'}
                  requiredLabel={true}
                  control={control}
                  name="anneeChaudiere"
                  options={convertToSelect(dd.anneesChaudiere)}
                  translateValue={true}
                  allowSearch={true}
                  size="large"
                  placeholder={`${t('BOILER_AGE')}`}
                />
              </group>

              <group data-length="autofit" data-direction="column" data-size="large">
                <Input
                  type={InputType.Select}
                  label={'BOILER_TYPE'}
                  requiredLabel={true}
                  control={control}
                  name="typeChaudiere"
                  options={convertToSelect(dd.typesChaudiere)}
                  translateValue={true}
                  allowSearch={true}
                  size="large"
                  placeholder={`${t('BOILER_TYPE')}`}
                />
              </group>

              <group data-length="autofit" data-direction="column" data-size="large">
                <Input
                  type={InputType.Select}
                  label={'BOILER_ENERGY'}
                  requiredLabel={true}
                  control={control}
                  name="energieChaudiere"
                  options={convertToSelect(dd.energiesChaudiere)}
                  translateValue={true}
                  allowSearch={true}
                  size="large"
                  placeholder={`${t('BOILER_ENERGY')}`}
                />
              </group>

              <group data-length="autofit" data-direction="column" data-size="large">
                <Input
                  type={InputType.Number}
                  label={'BOILER_POWER'}
                  requiredLabel={true}
                  control={control}
                  name="puissanceChaudiere"
                  size="large"
                  placeholder={`${t('BOILER_POWER')}`}
                />
              </group>
            </group>
          )}

          <group data-direction="column" data-gap="20">
            <text data-weight="600" data-text-size="large" data-ellipsis="" data-color="grey-color-dark">
              {t('DOMESTIC_HOT_WATER')}
            </text>

            <div>
              <text data-wrap="wrap" data-text-size="medium" data-name="custom_label">
                {t('HOT_WATER_TYPE')}
                <i data-space-horizontal="5" data-color="red">
                  *
                </i>
              </text>
            </div>

            <group data-gap="20" data-align="center" data-name="custom_option">
              <CustomSelector
                itemLength="180"
                name="typeECS"
                control={control}
                items={data.typesECS}
                selected={typeECS}
                onChange={ontypeECSChange}
              />
            </group>
          </group>

          <group data-gap="20">
            {heatPumpType === '1' && (
              <group data-length="">
                <Input
                  type={InputType.Select}
                  label={DHWChoiceLabel}
                  requiredLabel={true}
                  control={control}
                  name="DHWChoice2"
                  options={convertToSelect(data.IDU_types)}
                  onChange={(e: any) => onChangeDHWChoice2(e)}
                  translateValue={true}
                  allowSearch={true}
                  size="large"
                  placeholder={`${t('HOT_WATER_TYPE')}`}
                  disabled={!(heatPumpType === '1' && typeECS && typologie) || (isThermor && typeECS === 'integree')}
                  dataLength="autofit"
                />
              </group>
            )}
            <group data-length="forcefit" data-max-length="300">
              <Input
                type={InputType.Select}
                label={'OCCUPANTS_NUMBER'}
                requiredLabel={!(!typeECS || typeECS === 'sans')}
                control={control}
                name="nbOccupants"
                options={convertToSelect(dd.nbOccupants)}
                onChange={onnbOccupantsChange}
                allowSearch={true}
                size="large"
                disabled={!typeECS || typeECS === 'sans'}
                placeholder={`${t('OCCUPANTS_NUMBER')}`}
                dataLength="autofit"
              />
            </group>
          </group>

          {installation_survey &&
            <group data-length="autofit" data-gap="20">
              <group data-gap="10" data-space-vertical="10" data-radius="10" data-direction="row">
                <text data-weight="600" data-text-size="large" data-wrap="wrap" data-color="grey-color-dark">
                  {t("INSTALLATION_SURVEY_QUESTION")}
                  <i data-color="red">*</i>
                </text>
                <RadioGroupDelay
                  name="delay"
                  value={delay}
                  onChange={onDelayChange}

                />
              </group>
            </group>
          }
        </group>

        <NavigationButtons handleSubmit={submit} maxLength={850} horisontalSpace={20} />
      </group>
    </>
  )
}

export default ProjectStepHPChoice
